import { Component, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';

import { Campaign } from '../campaign.model';
import { CampaignService } from '../campaign.service';

import { SharedDataService } from '../../shared/data.service';

declare var $: any;

@Component({
 selector: 'wm-campaign-detail',
 template: require('./campaign-detail.component.html')
})
export class CampaignDetailComponent {
  campaign: Campaign;
  campaign_id: string;
  metrics: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: CampaignService,
    private shared: SharedDataService
  ) {
    this.route.params.subscribe(params => {
      this.metrics = params['metrics'];
      this.shared.awaitCampaign(params['id']).subscribe(campaign => {
        if (!!campaign) {
          this.campaign = campaign;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/components/campaign-detail.component.ts